(() => {
  const isFilterPage = () =>
    location.pathname.startsWith("/collections/") || location.pathname.startsWith("/search");
  if (!isFilterPage()) return;

  const GRID_ID = "products";
  const KEY_SNAP = "st_snap_to_grid_v1";
  const AUTO_APPLY_WHEN_NO_RESULTS = false;
  const SINGLE_SELECT_PER_FILTER = false;

  const pageHasNoResults = () => !!document.querySelector(".productgrid--no-results");
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;
  const qs = (sel, root = document) => root.querySelector(sel);

  const storage = {
    get(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (_) {
        return null;
      }
    },
    set(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (_) {}
    },
    remove(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (_) {}
    }
  };

  const snapToGrid = () => {
    const grid = document.getElementById(GRID_ID);
    if (!grid) return;
    const y = grid.getBoundingClientRect().top + window.scrollY - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: "auto" });
  };

  if (storage.get(KEY_SNAP)) {
    storage.remove(KEY_SNAP);
    requestAnimationFrame(() => snapToGrid());
  }

  let baseUrl = new URL(location.href);
  let pendingUrl = new URL(location.href);

  const getModalInner = () => qs(".modal-inner[data-modal-inner]");
  const getModalContent = () => qs(".modal-content[data-modal-content]");
  const modalOpen = () => !!getModalInner();

  const facetLinksIn = (root) =>
    Array.from(root.querySelectorAll('a.collection-filters__filter-link[data-name][data-value][data-filter-input]'));

  const setCheckmark = (anchor, checked) => {
    const svg = anchor.querySelector("svg.checkmark");
    if (!svg) return;
    const state = checked ? "checked" : "unchecked";
    svg.setAttribute("data-animation-state", state);
    svg.querySelectorAll("[data-animation-state]").forEach((node) => {
      node.setAttribute("data-animation-state", state);
    });
  };

  const clearAllURL = (url) => {
    const next = new URL(url.pathname, url.origin);
    ["grid_list", "sort_by", "q"].forEach((key) => {
      if (url.searchParams.has(key)) next.searchParams.set(key, url.searchParams.get(key));
    });
    return next;
  };

  const buildFacetURL = (url, name, value) => {
    const next = new URL(url.toString());
    next.searchParams.delete("page");

    const activeValues = next.searchParams.getAll(name);
    const isActive = activeValues.includes(value);

    if (!SINGLE_SELECT_PER_FILTER) {
      if (isActive) {
        const entries = Array.from(next.searchParams.entries());
        next.search = "";
        let removed = false;
        for (const [key, entryValue] of entries) {
          if (!removed && key === name && entryValue === value) {
            removed = true;
            continue;
          }
          next.searchParams.append(key, entryValue);
        }
      } else {
        next.searchParams.append(name, value);
      }
      return next;
    }

    const entries = Array.from(next.searchParams.entries());
    next.search = "";
    for (const [key, entryValue] of entries) {
      if (key === name) continue;
      next.searchParams.append(key, entryValue);
    }
    if (!isActive) next.searchParams.append(name, value);
    return next;
  };

  const getChipsWrap = (modal) =>
    modal.querySelector("[data-facets-chips-host]") || modal.querySelector(".productgrid--filters--mobile");

  const buildChip = (modal, name, value) => {
    const li = document.createElement("li");
    li.className = "active-filter-group__item-wrapper";

    const anchor = document.createElement("a");
    anchor.className = "active-filter-group__item";
    anchor.setAttribute("data-filter-input", "");

    const removeUrl = buildFacetURL(pendingUrl, name, value);
    anchor.href = removeUrl.pathname + removeUrl.search;

    const label =
      facetLinksIn(modal)
        .find((item) => item.getAttribute("data-name") === name && item.getAttribute("data-value") === value)
        ?.textContent?.replace(/\(\s*\d+\s*\)/g, "")
        .trim() || value;

    const labelSpan = document.createElement("span");
    labelSpan.className = "active-filter-text";
    labelSpan.textContent = label;

    const iconWrap = document.createElement("span");
    iconWrap.className = "filter-icon--remove";

    const icon = document.createElement("span");
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = "x";

    iconWrap.appendChild(icon);
    anchor.append(labelSpan, iconWrap);
    li.appendChild(anchor);

    return li;
  };

  const buildClearAllChip = () => {
    const li = document.createElement("li");
    li.className = "active-filter-group--remove-all filter-item--grid-simple";

    const anchor = document.createElement("a");
    anchor.className = "filter-item-clear-all";
    const cleared = clearAllURL(pendingUrl);
    anchor.href = cleared.pathname + cleared.search;
    anchor.textContent = "Clear all";

    li.appendChild(anchor);
    return li;
  };

  const syncModalUI = () => {
    const modal = getModalContent();
    if (!modal) return;

    facetLinksIn(modal).forEach((anchor) => {
      const name = anchor.getAttribute("data-name");
      const value = anchor.getAttribute("data-value");
      if (!name) return;

      const isActive = pendingUrl.searchParams.getAll(name).includes(value);
      const listItem = anchor.closest(".collection-filters__filter-list-item");
      if (listItem) {
        listItem.classList.toggle("collection-filters__filter-list-item--active", isActive);
        listItem.setAttribute("data-filter-open", isActive ? "true" : "false");
      }

      setCheckmark(anchor, isActive);

      const next = buildFacetURL(pendingUrl, name, value);
      anchor.setAttribute("href", next.pathname + next.search);
    });

    const chipsWrap = getChipsWrap(modal);
    if (!chipsWrap) return;

    let list = chipsWrap.querySelector("ul.active-filter-group");
    if (!list) {
      list = document.createElement("ul");
      list.className = "active-filter-group";
      chipsWrap.appendChild(list);
    }

    const activePairs = [];
    for (const [key, value] of pendingUrl.searchParams.entries()) {
      if (key.startsWith("filter.")) activePairs.push([key, value]);
    }

    list.replaceChildren();

    if (!activePairs.length) {
      chipsWrap.style.display = "none";
      return;
    }

    activePairs.forEach(([name, value]) => {
      list.appendChild(buildChip(modal, name, value));
    });
    list.appendChild(buildClearAllChip());
    chipsWrap.style.display = "";
  };

  document.addEventListener(
    "click",
    (event) => {
      if (!isMobile()) return;
      const button = event.target?.closest?.("[data-productgrid-trigger-filters], .utils-filter-button");
      if (!(button instanceof HTMLElement)) return;

      baseUrl = new URL(location.href);
      pendingUrl = new URL(location.href);

      setTimeout(() => {
        if (modalOpen()) syncModalUI();
      }, 60);
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      if (!isMobile() || !modalOpen()) return;

      const modal = getModalContent();
      if (!modal) return;

      const anchor = event.target?.closest?.("a");
      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (!modal.contains(anchor)) return;

      if (
        anchor.classList.contains("collection-filters__filter-link") &&
        anchor.hasAttribute("data-name") &&
        anchor.hasAttribute("data-value")
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const name = anchor.getAttribute("data-name");
        const value = anchor.getAttribute("data-value");
        if (!name || value == null) return;

        pendingUrl = buildFacetURL(pendingUrl, name, value);
        syncModalUI();
        return;
      }

      if (anchor.classList.contains("active-filter-group__item")) {
        event.preventDefault();
        event.stopImmediatePropagation();

        pendingUrl = new URL(anchor.href, location.origin);
        pendingUrl.searchParams.delete("page");
        syncModalUI();

        if (AUTO_APPLY_WHEN_NO_RESULTS && pageHasNoResults()) {
          storage.set(KEY_SNAP, "1");
          location.href = pendingUrl.toString();
        }
        return;
      }

      if (anchor.classList.contains("filter-item-clear-all")) {
        event.preventDefault();
        event.stopImmediatePropagation();

        pendingUrl = new URL(anchor.href, location.origin);
        pendingUrl.searchParams.delete("page");
        syncModalUI();

        if (AUTO_APPLY_WHEN_NO_RESULTS && pageHasNoResults()) {
          storage.set(KEY_SNAP, "1");
          location.href = pendingUrl.toString();
        }
      }
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target?.closest?.(".filters-modal-apply");
      if (!(button instanceof HTMLButtonElement)) return;
      if (pendingUrl.toString() === baseUrl.toString()) return;

      storage.set(KEY_SNAP, "1");
      setTimeout(() => {
        location.href = pendingUrl.toString();
      }, 80);
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      if (isMobile()) return;

      const anchor = event.target?.closest?.("a[href]");
      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const url = new URL(anchor.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname !== location.pathname) return;

      const looksRelevant =
        url.search !== location.search &&
        (url.search.includes("filter.") ||
          url.searchParams.has("page") ||
          url.searchParams.has("sort_by") ||
          url.searchParams.has("grid_list") ||
          anchor.hasAttribute("data-filter-input"));

      if (!looksRelevant) return;
      storage.set(KEY_SNAP, "1");
    },
    true
  );
})();
